import React, { useRef, useState, useEffect  } from 'react';
import "./Heading.scss";

const Heading = (props) => {
    return (
        <>
            <div className="judul">
                <p className="nama">{props.nama}</p>
                <p dangerouslySetInnerHTML={{ __html:props.job }}className="job" style={props.style}></p>
            </div>
        </>
    )
}

export default Heading;